import { useState } from 'react';

/**
 * 선택된 인덱스를 관리하는 hook입니다.
 * 같은 인덱스를 다시 클릭하면 선택 해제됩니다.
 */
export const useSelectedIndex = () => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  const toggleSelect = (index: number) => {
    setSelectedIndex(index === selectedIndex ? null : index);
  };

  const clearSelection = () => {
    setSelectedIndex(null);
  };

  return {
    selectedIndex,
    toggleSelect,
    clearSelection,
  };
};
